import { type ReactElement } from 'react'
import { AuthenticatedLayout } from '../../shared/components/layouts/AuthenticatedLayout'
import { RecurringPaymentsTableContainer } from '../../routes/app/recurring-charges/index/RecurringPaymentsTableContainer'

export const APP_RECURRING_PAYMENTS_PATH = '/app/recurring-charges'

function RecurringPaymentsPage (): ReactElement {
  return <RecurringPaymentsTableContainer />
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
RecurringPaymentsPage.getLayout = function getLayout (page: ReactElement) {
  return (
    <AuthenticatedLayout>
      {page}
    </AuthenticatedLayout>
  )
}
export default RecurringPaymentsPage
